
import { defineComponent } from 'vue';
import TransitionExpand from '@/components/ui/TransitionExpand.vue';

export default defineComponent({
  name: 'CodeExampleSource',
  components: {
    TransitionExpand,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});
